import React, {Component} from 'react'
import {CardElement, injectStripe} from 'react-stripe-elements';
import API_Root from "../../../Constants/API_Root";
import { Input, Message, Button, Icon } from 'semantic-ui-react'
import addCommaToNumbers from "../../../Constants/addCommaToNumbers";
import {getTotalPriceForCredits} from "../../../Constants/getTotalPriceForCredits";
import monthlyPricing from "../../../Constants/monthlyPricing";
import currencyInfo from "../../../Constants/currencyInfo";

class CreditCardDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            cardSuccess: null,
            name: '',
            submitDisabled: true,
            loading: false
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.submit = this.submit.bind(this);
        this.dismissMessage = this.dismissMessage.bind(this);

    }

    dismissMessage(){
        this.setState({ cardSuccess: null })
    }

    handleInputChange(e){
        this.setState({
            name: e.target.value
        })
    }

    async submit(e) {
        this.setState({
            loading: true
        })

        const failedMessage = "Your Payment Failed!";
        let {token} = await this.props.stripe.createToken({name: "Name"});
        if (token !== undefined){
            let response = await fetch(API_Root + "api/charge-clean-spreadsheets/", {
                method: "POST",
                headers: {Accept: 'application/json, text/plain, */*',},
                body: JSON.stringify({
                    stripeToken: token.id,
                    token: localStorage.getItem("token"),
                    email: localStorage.getItem("email"),
                    currency: this.props.currency,
                    credits: this.props.credits,
                    totalPrice: getTotalPriceForCredits(this.props.currency, this.props.credits, this.props.isPro),
                    customerName: this.state.name,
                    cardInfo: this.props.cardInfo,
                    planInfo: this.props.planIdx === -1 ? {} : monthlyPricing[this.props.currency][this.props.planIdx],
                    planIdx: this.props.planIdx,
                    isPro: this.props.isPro
                })
            }).then().catch(err =>
                this.setState({
                    loading: false,
                    cardSuccess: <Message error
                                          onDismiss={this.dismissMessage}
                                          header={failedMessage}
                                          content="Please try again!"
                    />
                })
            );

            if (response !== undefined){
                if (response.ok){
                    this.setState({
                        loading: false,
                        cardSuccess: <Message positive={true}
                                              onDismiss={this.dismissMessage}
                                              header="Your payment was a success!"
                                              content={this.props.signUp ? <a href="/clean">Start Cleaning Your Files Today!</a> : "Congratulations on upgrading! Enjoy the soft credit limits and awesome support. You can keep doing what you were doing now."}
                        />
                    }, () => this.props.planIdx === -1 ? this.props.updateUserCredits() : this.props.updateUserSubscription())
                    this.props.openCongratsModal()
                }
                else{
                    this.setState({
                        loading: false,
                        cardSuccess: <Message error
                                              onDismiss={this.dismissMessage}
                                              header={failedMessage}
                                              content="Please try again!"
                        />
                    })
                }
            }
        }
        else{
            this.setState({
                loading: false,
                cardSuccess: <Message error
                                      onDismiss={this.dismissMessage}
                                      header={failedMessage}
                                      content="Please enter all details and try again!"
                />
            })
        }
    }

    render() {
        return (
            <div className="checkout">
                <div style={{display: this.props.cardInfo === null ? "block" : "none"}}>
                    <Input icon="user"
                           iconPosition='left'
                           placeholder="Name on Card"
                           onChange={this.handleInputChange}
                           value={this.state.name} fluid />
                    <br/>
                    <div className="semanticBorder">
                        <CardElement />
                    </div>
                </div>
                <br/>
                <div style={{display: 'flex', justifyContent: 'center'}}>
                    <Button disabled={this.props.credits === null} color="green" loading={this.state.loading} onClick={this.submit} style={{textAlign: 'center'}} size="big">
                        {/*{this.props.planIdx !== -1 ? "Upgrade for " + currencyInfo[this.props.currency].symbol + monthlyPricing[this.props.currency][this.props.planIdx].price.toString() : "Refill " + this.props.credits === null ? null : addCommaToNumbers(this.props.credits) + " Credits"}*/}
                        <Icon name="dollar" /> { "Refill " +  addCommaToNumbers(this.props.credits) + (this.props.isPro ? " Pro " : " Basic ") + " Credits"}
                    </Button>
                </div>
                <br/>
                {this.state.cardSuccess}
            </div>
        )
    }
}

export default injectStripe(CreditCardDetails)